<router-outlet>
</router-outlet>
<eazly-footer></eazly-footer>
